import { render, staticRenderFns } from "./BoardAromArea.vue?vue&type=template&id=5c870164&scoped=true&"
import script from "./BoardAromArea.vue?vue&type=script&lang=js&"
export * from "./BoardAromArea.vue?vue&type=script&lang=js&"
import style0 from "./BoardAromArea.vue?vue&type=style&index=0&id=5c870164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c870164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c870164')) {
      api.createRecord('5c870164', component.options)
    } else {
      api.reload('5c870164', component.options)
    }
    module.hot.accept("./BoardAromArea.vue?vue&type=template&id=5c870164&scoped=true&", function () {
      api.rerender('5c870164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/components/Home/components/BoardAromArea.vue"
export default component.exports